import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "appearance", "tag", "layout", "href", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { AppearanceProvider, useAppearance } from '@segment/matcha/foundations/AppearanceContext';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Card.views';
import { CardContextProvider } from './CardContext';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var BaseCard = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      externalAppearance = _ref.appearance,
      tag = _ref.tag,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? "vertical" : _ref$layout,
      href = _ref.href,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  var appearance = useAppearance(externalAppearance);
  return _jsx(AppearanceProvider, {
    appearance: appearance === "twilioLight" || appearance === "cdpWeek2023" ? appearance : "light",
    children: _jsx(CardContextProvider, {
      value: {
        layout: layout
      },
      children: _jsx(views.Wrapper, _objectSpread(_objectSpread({
        as: tag !== null && tag !== void 0 ? tag : href ? "a" : undefined,
        href: href,
        ref: ref
      }, rest), {}, {
        children: _jsx(views.Card, _objectSpread(_objectSpread({
          layout: layout,
          elevation: 2
        }, tokens), {}, {
          children: children
        }))
      }))
    })
  });
});
export var Card = withDesignTokens(BaseCard, function (props) {
  return {
    pointerEvents: props.tag === "a" ? "none" : "auto"
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700],
      descriptionColor: theme.palette.brand.darkAcai[700],
      background: theme.palette.neutrals.white[100]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[700],
      descriptionColor: theme.palette.brand.darkAcai[700],
      background: theme.palette.neutrals.white[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100],
      descriptionColor: theme.palette.twilio.gray[100],
      background: theme.palette.neutrals.white[100]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      descriptionColor: theme.palette.cdpWeek2023.gray[10],
      background: theme.palette.cdpWeek2023.gray[90]
    };
  }
});
export default Card;